<template>
<!-- 轮播 -->
  <el-carousel
    :interval="5000"
    arrow="always"
    style="display: inline-block; width: 940px; height: 480px"
  >
    <el-carousel-item v-for="(item,index) in rotation" :key="index">
      <!-- style="width: 1128px; height: 470px" -->
      <el-image
        style="width: 100%; height: 470px"
        :src="item.url"
        fit="cover"
      ></el-image>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'Rotation',
  props: {
    parent: ''
  },
  watch: {
    parent: {
      handler(newVal, oldVal) {
        if (this.rotation != null) {
          this.rotation = newVal;
          this.getList();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      rotation: [],
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
        this.rotation = this.parent
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/PC/rotation/Rotation.vue